import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {ResultatStoreService} from '../../berakningshjalpen/stores/resultat.store';

@Injectable({
  providedIn: 'root'
})
export class RouterGuard implements CanActivate {

  constructor(
    private readonly resultatStoreService: ResultatStoreService,
    private readonly router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.resultatStoreService.resultatData.resultatDtos.length > 0) {
      return true;
    } else {
      return this.router.parseUrl('/');
    }
  }
}
